module.exports = __webpack_public_path__ + "static/background-b8001d168353c00beffb4643d4c89865.png";